import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/global.css';
import { AuthProvider } from './context/AuthContext';
import { ChartPaletteProvider } from './context/ChartPaletteContext';
import { ChatProvider } from './learning/chat';
import { installGlobalErrorHandlers } from './utils/monitoring';

installGlobalErrorHandlers();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <ChartPaletteProvider>
        <ChatProvider>
          <App />
        </ChatProvider>
      </ChartPaletteProvider>
    </AuthProvider>
  </React.StrictMode>
);
